import Vue from 'vue'
import VueRouter from 'vue-router'
import IntroDuction from '../views/IntroDuction.vue'
import Login from '../LoginPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Introduction',
    component: Login
  },
  {
    path: '/intro',
    name: 'intro',
    component: IntroDuction
  },
  {
    path: '/quiz',
    name: 'Start Quiz',
    component: () => import('../views/QuizInit.vue')
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: () => import('../views/WelcomeScreen.vue')
  },
  {
    path: '/music',
    name: 'Music',
    component: () => import('../views/Home/MusicPage.vue')
  },
  {
    path: '/home',
    component: () => import('../views/HomePage.vue'),
    children: [
      {
        path: '',
        component: () => import('../views/Home/DashBoard.vue')
      },
      {
        path: 'music',
        component: () => import('../views/Home/MusicPage.vue')
      },
      {
        path: 'profile',
        component: () => import('../views/Home/ProfilePage.vue')
      },
      {
        path: 'tasks',
        component: () => import('../views/Home/TasksPage.vue')
      },
      {
        path: 'sleep',
        component: () => import('../views/Home/SleepPage.vue')
      },
      {
        path: 'chat',
        component: () => import('../views/Home/ChatWindow.vue')
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



export default router
